import axios from 'axios';
import React, { useEffect, useState } from 'react';
import '../TypeList/type.css';

const CommentList = () => {
    const [comments, setComments] = useState([]);

    useEffect(() => {
        getComment(); 
    }, []);

    const getComment = () => {
        axios.get('https://pkrealestateapi.onrender.com/comment')
            .then(res => {
                console.log(res.data.comments);
                setComments(res.data.comments);
            })
            .catch(err => {
                console.log(err);
            });
    };

    const deleteComment = (commentId) => {
        
        if (window.confirm("Are you sure you want to delete this item?")) {
            axios.delete(`https://pkrealestateapi.onrender.com/comment/${commentId}`)
                .then(res => {
                    console.log(res);
                    getComment(); 
                })
                .catch(err => {
                    console.log(err);
                });
        }
    };

    return (
        <div className="container">
            {comments.length > 0 ? (
                comments.map(data => (
                    <div className='typecard' key={data._id}>
                        <p>{data.email}</p>
                        <p>{data.commentText}</p>
                        <p>{data.propertyId}</p>
                        <p>{data.timestamp}</p>
                        <button onClick={() => deleteComment(data._id)} className="delete-btn">Delete</button>
                    </div>
                ))
            ) : (
                <p>No comments available.</p> 
            )}
        </div>
    );
};

export default CommentList;